import rdoImage from "@/assets/landing/rdo.jpg";
import { CheckIcon } from "@/components/icon";

export function RdoPreview() {
	return (
		<div data-slot="rdo">
			<div data-slot="rdo-stage">
				<img
					data-slot="rdo-page"
					src={rdoImage}
					alt="Primeira página do Relatório de Obra nº 128, revisão 2, do Residencial Alto da Serra, Torre B, em 11/09/2026"
					width={638}
					height={900}
				/>
				<div data-slot="rdo-bar">
					<b data-slot="rdo-number">Relatório de Obra nº 128 · Revisão 2</b>
					<span data-slot="rdo-status">
						<CheckIcon />
						Finalizado · PDF gerado às 18:42
					</span>
				</div>
			</div>
		</div>
	);
}
